import { mainSheet } from './models/StyleSheetManager';
import StyleSheet from './sheet';
export var __PRIVATE__ = {
    StyleSheet: StyleSheet,
    mainSheet: mainSheet,
};
//# sourceMappingURL=secretInternals.js.map